import { render, staticRenderFns } from "./GroupsAdmin.vue?vue&type=template&id=47a41a68&scoped=true&"
import script from "./GroupsAdmin.vue?vue&type=script&lang=js&"
export * from "./GroupsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./GroupsAdmin.vue?vue&type=style&index=0&id=47a41a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a41a68",
  null
  
)

export default component.exports